import { useNavigate } from "react-router-dom";
import Folder from "../atoms/Folder";
import CardHeader from "../atoms/CardHeader";
import aledraLogo from "../../assets/imgs/aledra.png";
import comerdesaLogo from "../../assets/imgs/comerdesa.png";
import Heading from "../atoms/Heading";
import Breadcrumb from "../molecules/Breadcrumb";

const data = [
    {id:1, name:"Aledra", img:aledraLogo },
    {id:2, name:"Comerdesa", img:comerdesaLogo },
    {id:3, name:"Otros" },
];

const InmobiliariasTemplate = () => {
    const navigate = useNavigate();

    return(
        <div className="w-full flex flex-col gap-4">
            <CardHeader 
                left={
                            <Breadcrumb
                              items={[
                                { label: "Inicio", to: `/inicio` },
                                { label: "Inmobiliarias", to: null },
                              ]}
                            />
                          } />
            <div className="w-full gap-4 grid grid-cols-1 md:grid-cols-2">
                {data.map((im) => (
                    <Folder
                        key={im?.id}
                        onClick={() => navigate(`${im.id}`)}
                        children={
                            <div className="h-full flex flex-col text-center items-center justify-center">
                                {im?.img ?
                                    <img alt={im.name} src={im.img} className="max-h-[25vh] w-auto"/>
                                    :
                                    <Heading text="Otros" color="white" />
                                }
                            </div>
                        }
                    />
                ))}
            </div>
        </div>
    );
};

export default InmobiliariasTemplate;